<section class="cart-summary-shell">
  <header class="cart-summary-header">
    <h1>Shopping Cart</h1>
    <p>Review your items and proceed to checkout.</p>
  </header>

  <div class="cart-summary-layout">
    <div class="cart-table-card">
      <div class="cart-table-header" aria-label="Shopping cart columns">
        <span class="header-product">Product</span>
        <span class="header-qty">Qty</span>
        <span class="header-unit">Sales Unit</span>
        <span class="header-remove"></span>
      </div>

      @for (item of cartItems; track item.id) {
        <div class="cart-item-row">
          <div class="product-cell" (click)="goToDetail(item,$event)">
            <!-- <div class="product-thumb" [class.small]="item.compactThumb" aria-hidden="true">
              <span class="thumb-brand">{{ item.brand }}</span>
              <span class="thumb-meta">{{ item.productCode }}</span>
            </div> -->
            <div class="product-thumb" [class.small]="item.compactThumb" aria-hidden="true">
            <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
                [alt]="item?.product?.images?.altText">
              </cx-media>
              </div>
            <div class="product-details">
              <h2>{{ item.name }}</h2>
              <p class="product-code">Material #: {{ item.partNumber }}</p>
            </div>
          </div>

          <div class="quantity-cell">
            <div class="quantity-editor" aria-label="Quantity selector">
              <button type="button" aria-label="Decrease quantity" (click)="decreaseQuantity(item.id)">−</button>
              <input
                type="number"
                min="1"
                [value]="item.quantity"
                aria-label="Product quantity"
                (input)="onQtyChange(item.id, $event)"
              />
              <button type="button" aria-label="Increase quantity" (click)="increaseQuantity(item.id)">+</button>
            </div>

            @if (shouldShowOverageReason(item)) {
              <div class="overage-reason-row">
                <label class="overage-label" [for]="'reason-' + item.id">Reason for quantity overage</label>
                <textarea
                  [id]="'reason-' + item.id"
                  rows="1"
                  placeholder="Reason for quantity overage..."
                  [(ngModel)]="item.overageReason"
                  (input)="onOverageReasonInput(item, $event)"
                ></textarea>
              </div>
            }
          </div>

          <div class="sales-unit-cell">
            <span class="sales-unit-value">{{ item.salesUnit }}</span>
          </div>

          <div class="remove-cell">
            <button type="button" class="remove-item" aria-label="Remove item" (click)="removeCartItem(item.id)">×</button>
          </div>
        </div>
      }
    </div>

    <aside class="checkout-panel">
      <label class="order-number-label" for="jobNumber">PO/Job Number</label>
      <input id="jobNumber" type="text" placeholder="Enter PO or Job Number" [(ngModel)]="poNumber" (input)="onPoNumberInput($event)" />
      @if (poNumberError) {
        <p class="po-number-error" role="alert">{{ poNumberError }}</p>
      }
      <button type="button" class="primary-button" [disabled]="checkoutDisabled" (click)="proceedToCheckout()">Proceed to Checkout</button>
      <button (click)="navigate('/search/active-brands')" type="button" class="secondary-button">Continue Shopping</button>
    </aside>
  </div>
</section>
